import { ProposalProduct } from "../../project/models/ProposalProduct";

export const getEffectiveUnitPrice = (product: ProposalProduct): number =>
    product.adjustedPrice ?? product.product.price.valueVatExcl;

export const getProposalProductsTotal = (products: ProposalProduct[]): number =>
    (products ?? []).reduce((sum, p) => sum + getEffectiveUnitPrice(p) * p.quantity, 0);
